import React, { useEffect, useState, useRef } from "react"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"

import Nav from "./Nav/"
import DataLoader from "./DataLoader"
import afterFirstPaint from "./utils/afterFirstPaint"
import { routesReversed } from "./routes"

import "./App.scss"

function App() {
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    // Start loading once the first content has painted, so the home page
    // headline shows before any data is requested. Lighthouse then doesn't
    // count the data downloads as part of the time to show it (LCP).
    afterFirstPaint()
      .then(() => DataLoader.load())
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  const [fade, setFade] = useState(false)
  const updateFade = (bool) => setFade(bool)

  const navRef = useRef(null)
  const path = process.env.PUBLIC_URL.replace(/^https?:\/\/[^/]+\/?/, "")
  const basename = path[0] === "/" ? path : `/${path}`
  return (
    <div>
      <Router basename={basename}>
        <Route path="/:page?/:opt1?/:opt2?/:opt3?/:opt4?">
          <Nav navRef={navRef} />
        </Route>
        <main>
          <Switch>
            {routesReversed.map((link) => (
              <Route path={link.route} key={link.url}>
                {isLoading && !link.rendersBeforeData ? (
                  <div className="loaderContainer">Loading...</div>
                ) : (
                  <link.component
                    navRef={navRef}
                    fade={fade}
                    setFade={updateFade}
                    dataLoaded={!isLoading}
                  />
                )}
              </Route>
            ))}
          </Switch>
        </main>
      </Router>
      <div id="tooltip"></div>
    </div>
  )
}

export default App
